export default __webpack_public_path__ + "static/media/check-in-location.0e4dd7c9.png";